import React, { useState } from "react";
import Card from "../../../components/Card";
import styles from "./CollectionDetail.module.sass";
import { UseDisclosure } from "../../../hooks/use-disclosure";
import ProductModal from "../../../components/ProductModal";
import Icon from "../../../components/Icon";
import cn from "classnames";

const CollectionDetail = ({ data, closeProduct }) => {
	const { isOpen, onClose, onOpen } = UseDisclosure();
	const [product, setProduct] = useState();
	const close = () => {
		setProduct();
		onClose();
	};

	const status = data.nftTemplates.map((e) => e.status);

	const open = (data_) => {
		setProduct(data_);
		onOpen();
	};

	return (
		<>
			<Card
				className={styles.card}
				title="Drop details"
				classTitle="title-yellow"
				head={
					<button className={styles.close} onClick={closeProduct}>
						<Icon name="close" size="20" />
					</button>
				}
			>
				<div className={styles.productName}>
					<img src={data.image} alt={data.name} />
					<div>
						<div className={styles.title}>{data.name}</div>
					</div>
					<div className={styles.button}>
						{status.every((e) => e === "OPEN") && (
							<div className={styles.open}>OPEN</div>
						)}
						{status.every((e) => e === "CLOSED") && (
							<button className="button">MINT</button>
						)}
						<button className="button">MINT</button>
						{status.some((e) => e === "MINTING") && (
							<div className={styles.minted}>MINTING</div>
						)}
						{status.every((e) => e === "MINTED") && (
							<div className={styles.minted}>MINTED</div>
						)}
					</div>
				</div>

				<div className="title-green">Description</div>
				<div>{data.description}</div>
				<div className="title-red">Products</div>
				<div className={styles.container}>
					{data.nftTemplates.map((e) => (
						<ProductCard key={e._id} data={e} open={open} />
					))}
				</div>
			</Card>
			<ProductModal
				visible={isOpen && product}
				onClose={close}
				data={product}
			/>
		</>
	);
};

const Type = {
	LIMITED_EDITION: "LIMITED",
	OPEN_EDITION: "OPEN",
	SINGLE_EDITION: "SINGLE",
};

const ProductCard = ({ data, open }) => {
	return (
		<div
			onClick={() => {
				open(data);
			}}
			className={styles.card}
		>
			<div className={cn(styles.cardStatus, styles[data.status])}>
				<div className={styles.type}>{Type[data.type]}</div>/{data.totalNFTs}
			</div>
			<div className={styles.img}>
				<img src={data.image} alt={data.name} />
			</div>
			<div className={styles.nftTitle}>{data.name}</div>
			<div className={styles.price}>
				<div>Direct sale price</div>
				<div>$ {data.price}</div>
			</div>
		</div>
	);
};

export default CollectionDetail;
